function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14"
  }, props), React.createElement("path", {
    style: {
      "fill": "#7d7d7d"
    },
    className: "cls-1",
    d: "M13.06.832H9.485V.66C9.485.1,9.023,0,8.459,0H5.522C4.958,0,4.5.1,4.5.66V.832H.939a.608.608,0,0,0-.609.609V2.617a.609.609,0,0,0,.609.609H13.06a.609.609,0,0,0,.609-.609V1.441A.609.609,0,0,0,13.06.832Z"
  }), React.createElement("path", {
    style: {
      "fill": "#7d7d7d"
    },
    className: "cls-1",
    d: "M11.782,4.844H2.217a.61.61,0,0,0-.6.685l.981,7.422A1.2,1.2,0,0,0,3.781,14h6.437a1.2,1.2,0,0,0,1.188-1.049l.98-7.422A.609.609,0,0,0,11.782,4.844Z"
  }));
};
export default __webpack_public_path__ + "static/media/delete.60dfcdee.svg";
export { SvgComponent as ReactComponent };